export default "__VITE_ASSET__6758d22a__"